import {
  SearchOutlined,
  SolutionOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import {
  actionConstants,
  appConstants,
  guideConstants,
  resourceConstants,
  roleConstants,
} from 'constants/index';
import {
  CUSTOMER_MANAGEMENT_PATHS,
  STAFF_MANAGEMENT_PATHS,
  USER_SEGMENT_PATHS,
} from 'constants/paths';
import { commonHelpers } from 'helpers';
import { t } from 'helpers/i18n';
import { getSrc } from 'helpers/url';
import { lazy } from 'react';

// ERP2020-562 new routes
import PageUpgrading from 'containers/shared/PageUpgrading';
import configHelpers from 'helpers/config';
import accountingRoutes from './accounting';
import campaignManagement from './campaignManagement';
import cashierRoutes from './cashier';
import dposRoutes from './dpos';
import entityRoutes from './entity';
import invoiceRoutes from './invoice';
import logisticRoutes from './logistic';
import loyaltyServiceRoutes from './loyaltyService';
import orderRoutes from './order';
import pageBuilderRoutes from './pageBuilder';
import productRoutes from './product';
import promotionRoutes from './promotion';
import purchasingRoutes from './purchasing';
import reportRoutes from './report';
import reportV2Routes from './report-v2';
import seoManagementRoutes from './seoManagement';
import settingRoutes from './setting';
import sgcToolRoutes from './adhoc-tool';
import staffManagementRoutes from './staffManagement';
import ticketRoutes from './ticket';
import userNotificationRoutes from './userNotification';
import warehousingRoutes from './warehousing';

const { getCommonConfig } = configHelpers;
const { baseSellerCenterV2Url, baseUserSegmentUrl } = getCommonConfig();

const { SELLERS, STAFF_BFF, USER_SEGMENT_BFF } = appConstants;
const { LEGACY_STAFF_MANAGEMENT } = roleConstants;
const { DEALER, PROFILE_360_LOOKUP } = resourceConstants;
const { READ, READ_UI } = actionConstants;
const { permission } = commonHelpers;
const { SERVICE_CODE, USER_GUIDE_CODE } = guideConstants;

// Pages
const IFrameContainer = lazy(() => import('containers/shared/IFrameContainer'));

export default [
  ...orderRoutes,
  ...ticketRoutes,
  ...productRoutes,
  ...promotionRoutes,
  ...campaignManagement,
  ...loyaltyServiceRoutes,
  ...pageBuilderRoutes,
  ...purchasingRoutes,
  ...cashierRoutes,
  ...invoiceRoutes,
  ...accountingRoutes,
  ...warehousingRoutes,
  ...logisticRoutes,
  ...sgcToolRoutes,
  {
    exact: true,
    path: '/customer-management',
    name: t('CustomerManagement'),
    icon: SolutionOutlined,
    component: IFrameContainer,
    iFrameSrc: getSrc(baseSellerCenterV2Url, CUSTOMER_MANAGEMENT_PATHS.Dealers),
    permissions: [permission(SELLERS, DEALER, READ_UI)],
    guide: {
      serviceCode: SERVICE_CODE.OMNI,
      userGuideCode: USER_GUIDE_CODE.CUSTOMER_MANAGEMENT,
    },
  },
  {
    exact: true,
    path: '/profile-360-lookup',
    name: t('Profile360Lookup'),
    icon: SearchOutlined,
    component: IFrameContainer,
    iFrameSrc: getSrc(baseUserSegmentUrl, USER_SEGMENT_PATHS.Profile360Lookup),
    permissions: [permission(USER_SEGMENT_BFF, PROFILE_360_LOOKUP, READ)],
  },
  ...dposRoutes,
  ...userNotificationRoutes,
  {
    exact: true,
    path: '/staff-management',
    name: t('StaffManagement'),
    icon: TeamOutlined,
    component: IFrameContainer,
    iFrameSrc: getSrc(baseSellerCenterV2Url, STAFF_MANAGEMENT_PATHS.Users),
    permissions: [permission(STAFF_BFF, LEGACY_STAFF_MANAGEMENT)],
    usePermissionPrefix: true,
  },
  ...settingRoutes,
  ...reportRoutes,
  ...reportV2Routes,
  ...entityRoutes,
  ...staffManagementRoutes,
  ...seoManagementRoutes,
  {
    exact: true,
    path: '/upgrading',
    name: t('Upgrading'),
    component: PageUpgrading,
  },
];
